

import cases from '../../api/case'

export default {
    data(){
        return {
            page : 1 ,
            pageSize : 10 ,
            list : [],
            total : 0,
            postMain : false
        }
    },

    created(){
        this.getCaseList();
    },

    methods:{
        getCaseList(bool){
            let {page,pageSize,list} = this;
            cases.getPageProjectList({page,pageSize}).then(res=>{
                bool ? this.list = list.concat(res.pageList) : this.list = res.pageList;
                this.total = res.total;
            })
        },
        infinite(){
            if(this.postMain){
                this.page++;
                this.getCaseList(true);
            }else{
                this.postMain = true;
            }
            this.$refs.caseScroller.finishInfinite(true)
        }
    }

}